import Icon from '../components/Icon.vue'

Icon.register({"stack-overflow":{"width":1536,"height":1792,"paths":[{"d":"M1289 1632h-1118v-480h-160v640h1438v-640h-160v480zM347 1108l33-157 783 165-33 156zM450 734l67-146 725 339-67 145zM651 378l102-123 614 513-102 123zM1048 0l477 641-128 96-477-641zM330 1471v-159h800v159h-800z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/stack-overflow.js
// module id = jCN6
// module chunks = 1